import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getCurrencyConfigs } from 'services/bet-slip';
import { useCurrency } from 'hooks/useCurrency';
import { setRounding, setRoundingLoading } from 'store/actions/app-data';

export const useGetCurrencyConfigs = (): void => {
  const { currencyId } = useCurrency();
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (currencyId) {
      dispatch(setRoundingLoading(true));
      getCurrencyConfigs(
        currencyId,
        dataObj => {
          if (dataObj?.data) {
            const currency = dataObj.data.currency;

            if (currency) {
              const rounding = currency[Object.keys(currency)[0]]?.rounding;

              dispatch(setRounding(rounding));
            }
          }

          dispatch(setRoundingLoading(false));
        },
        () => {
          dispatch(setRoundingLoading(false));
        }
      );
    }
  }, [currencyId]);
};
